<template>
  <v-bottom-sheet v-model="stShowMusic" hide-overlay>
    <div id="hola"></div>
      <v-sheet class="text-right">
        <v-btn 
          icon
          color="primary"
          class="btn-close"
          @click="showMusic"
        >
          <v-icon class="font-size-32 white rounded-circle"> mdi-close-circle</v-icon>
        </v-btn>        
        <Music 
          v-if="!isChallengeFunctionality"
          is-book-functionality
          @close-music="showMusic"
          />
        <Music
          v-else
          is-challenge-functionality
          @close-music="showMusic"
          />
      </v-sheet>
  </v-bottom-sheet>
</template>

<script>
import { mapActions, mapState } from 'vuex';

import Music from '@/components/core/utils/Music.vue'

export default {
  data() {
    return {
      localIsChallengeFunctionality: false
    }
  },
  props: {
    isChallengeFunctionality: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Music,
  },
  methods: {
    ...mapActions('bookReading', [
      'showMusic',
    ]),
  },
  computed: {
    ...mapState({
      stShowMusic: (state) => state.bookReading.mobileTools.showMusic,
    })
  },
  created() {
    this.utilsToggleHandler = (challengeFx) => {
      try {
        this.localIsChallengeFunctionality = challengeFx;
      } catch (error) {
        console.error('Error en utilsToggleHandler (MusicSheet):', error);
      }
    };
    if (this.$root && typeof this.$root.$on === 'function') {
      this.$root.$on('utilsToggle', this.utilsToggleHandler);
    }
  },
  beforeDestroy() {
    if (this.$root && typeof this.$root.$off === 'function') {
      this.$root.$off('utilsToggle', this.utilsToggleHandler);
    }
  }
}
</script>

<style lang="scss">

.v-bottom-sheet{
  position: relative;
  .btn-close{
    position: absolute;
    right: 24px;
    left: inherit;
    top: 1em;
    z-index: 10;
  }
}


</style>